import PropTypes from 'prop-types';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import { load } from 'model/oneTimePasscode';
import { useDispatch, useSelector } from 'react-redux';
import { selector as pageSettingsSelector } from 'selectors/pageSetting';
import { formatOrderOffsetLimit } from 'util/page';
import { defaultPageSettings, pageSettingsName } from '../config';
import FilterByUsersAutocomplete from './FilterByUsersAutocomplete';
import GenerateButton from './GenerateButton';

const EndAdornment = ({ fspId, payerId, ...rest }) => {
  const dispatch = useDispatch();
  const pageSettings = useSelector((state) =>
    pageSettingsSelector(state, payerId, pageSettingsName, defaultPageSettings)
  );
  const handleRefresh = () => {
    const { order, orderBy, page, rowsPerPage, userId } = pageSettings;

    dispatch(
      load({
        ...formatOrderOffsetLimit({ order, orderBy, page, rowsPerPage }),
        ...(userId ? { userId } : {}),
        fspId,
        payerId,
      })
    );
  };

  return (
    <Grid alignItems="center" container spacing={2}>
      <Grid item>
        <FilterByUsersAutocomplete fspId={fspId} payerId={payerId} {...rest} />
      </Grid>
      <Grid item>
        <Tooltip title="Refresh OTP list">
          <IconButton
            aria-label="refresh otp list"
            onClick={handleRefresh}
            size="small"
          >
            <RefreshIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item>
        <GenerateButton fspId={fspId} payerId={payerId} {...rest} />
      </Grid>
    </Grid>
  );
};

EndAdornment.propTypes = {
  fspId: PropTypes.number.isRequired,
  payerId: PropTypes.number.isRequired,
};

export default EndAdornment;
